import { render } from "./form-input.vue?vue&type=template&id=dd8d3f76&scoped=true&lang=pug"
import script from "./form-input.vue?vue&type=script&lang=js"
export * from "./form-input.vue?vue&type=script&lang=js"

import "./form-input.vue?vue&type=style&index=0&id=dd8d3f76&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8d3f76"]])

export default __exports__